import DetailJumbotron from './DetailJumbotron'

export default DetailJumbotron
// eslint-disable-next-line import/export
export * from './DetailJumbotron'
